import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
  selector: 'app-property-selection',
  templateUrl: './property-selection.component.html',
  styleUrls: ['./property-selection.component.scss']
})

export class PropertySelectionComponent implements OnInit {
  @Input() properties;
  @Input() currentProperty;
  @Output() changeNewPropertyId = new EventEmitter();
  dataSourceForMatrix = [];


  newPropertyId: any;
  constructor() {
  }

  ngOnInit(): void {
    console.log(this.currentProperty);
    this.newPropertyId = this.currentProperty.id;

    const temp = JSON.parse(JSON.stringify(this.properties));
    const levelSet = new Set();
    temp.forEach((property) => {
      levelSet.add(property.level);
    });

    levelSet.forEach((level) => {
      this.dataSourceForMatrix.push({
        level: level,
        properties: this.properties.filter(property => property.level === level).sort(this.compareUnit)
      });
    });
    this.dataSourceForMatrix.sort(this.compareFloor);
  }

  compareFloor(a, b) {
    const levelA = a.level;
    const levelB = b.level;
    let comparison = 0;
    if (levelA < levelB) {
      comparison = 1;
    } else if (levelA > levelB) {
      comparison = -1;
    }
    return comparison;
  }

  compareUnit(a, b) {
    const unitA = a.unit;
    const unitB = b.unit;
    let comparison = 0;
    if (unitA > unitB) {
      comparison = 1;
    } else if (unitA < unitB) {
      comparison = -1;
    }
    return comparison;
  }

  transformLevel(level) {
    switch (level) {
      case -1:
        return 'GC';
      case -2:
        return 'GB';
      case -3:
        return 'GA';
      case -4:
        return 'G';
      case -5:
        return 'LG';
      case -6:
        return 'L';
      case -7:
        return 'B';
      case -8:
        return 'B1';
      case -9:
        return 'B2';
      case -10:
        return 'B3';
      case -11:
        return 'B4';
      case -12:
        return 'B5';
      default:
        return level;
    }
  }

  isCheckBoxSelected(propertyId: number) {
    return this.newPropertyId === propertyId;
  }

  select(event: MatCheckboxChange, propertyId) {
    // console.log(this.selectedProductIdArray);
    if (event.checked) {
      this.newPropertyId = propertyId;
    } else {
      this.newPropertyId = null;
    }
    this.changeNewPropertyId.emit({newPropertyId: this.newPropertyId});
  }

}
